export default "<!-- <button (click)=\"executeImportantAction()\">Important action</button> -->\n";